import React from 'react';

const PAYMENT_METHODS = [
  { name: 'Visa', src: '/payments/visa.svg' },
  { name: 'Mastercard', src: '/payments/mastercard.svg' },
  { name: 'WiPay', src: '/payments/wipay.svg' },
];

export default function PaymentMethodBadges() {
  return (
    <ul className="footer-payment-badges list-unstyled d-flex flex-wrap justify-content-center gap-2 mb-0">
      {PAYMENT_METHODS.map(({ name, src }) => (
        <li key={name}>
          <span className="footer-payment-badge" title={name}>
            <img src={src} alt={name} loading="lazy" />
          </span>
        </li>
      ))}
    </ul>
  );
}
